import OrderSearchModal from './components/OrderSearchModal';
import OrderSerialSearchSection from './components/OrderSerialSearchSection';
import PurchasedRepeaterOperationsSection from './components/PurchasedRepeaterOperationsSection';

/**
 * 購入済みのみ（IncludePurchasedRepeaters === true）向け Trunking / Repeater UI（#415 / T4）。
 * SO# Search、Add / Exchange / Remove、手動 Add Row を提供する。
 *
 * @param {{
 *   gen1Order: Object,
 *   orderNumber: string,
 *   otherSystemId: string,
 *   addRepeater: boolean,
 *   orderSearchLoading: boolean,
 *   orderSearchResult: Object[],
 *   orderSearchError: string,
 *   orderSearchModalOpen: boolean,
 *   orderNumberSearchSectionRef: import('react').RefObject<HTMLElement>,
 *   validationErrors: Object,
 *   onFormChange: (evn: object, data: object) => void,
 *   onSearchClick: () => void,
 *   onOrderSearchShowModalClick: () => void,
 *   onOrderSearchModalClose: () => void,
 *   onOrderSearchSelectAllChange: (evn: object, data: object) => void,
 *   onOrderSearchRowToggle: (idx: number) => void,
 *   onOrderSearchRegisterClick: () => void,
 *   onAddRepeaterRowClick: () => void,
 *   onRepeaterLineChange: (lineSequenceNumber: number, field: string, value: string) => void,
 *   onDeleteManualRepeaterRow: (lineSequenceNumber: number) => void,
 *   onDeleteSearchRepeaterRow: (lineSequenceNumber: number) => void,
 *   onDeleteRemoveRepeaterRow: (lineSequenceNumber: number) => void,
 *   onDeleteExchangeRepeaterPair: (pairId: number) => void,
 * }} props
 */
export default function Gen1ApplicationPurchasedTrunking({
    gen1Order,
    orderNumber = '',
    otherSystemId = '',
    addRepeater,
    orderSearchLoading = false,
    orderSearchResult = [],
    orderSearchError = '',
    orderSearchModalOpen = false,
    orderNumberSearchSectionRef,
    validationErrors = {},
    onFormChange,
    onSearchClick,
    onOrderSearchShowModalClick,
    onOrderSearchModalClose,
    onOrderSearchSelectAllChange,
    onOrderSearchRowToggle,
    onOrderSearchRegisterClick,
    onAddRepeaterRowClick,
    onRepeaterLineChange,
    onDeleteManualRepeaterRow,
    onDeleteSearchRepeaterRow,
    onDeleteRemoveRepeaterRow,
    onDeleteExchangeRepeaterPair,
}) {
    return (
        <>
            <OrderSerialSearchSection
                orderNumber={orderNumber}
                orderSearchLoading={orderSearchLoading}
                orderSearchResult={orderSearchResult}
                orderSearchError={orderSearchError}
                orderNumberSearchSectionRef={orderNumberSearchSectionRef}
                validationErrors={validationErrors}
                onFormChange={onFormChange}
                onSearchClick={onSearchClick}
                onOrderSearchShowModalClick={onOrderSearchShowModalClick}
            />

            <PurchasedRepeaterOperationsSection
                gen1Order={gen1Order}
                otherSystemId={otherSystemId}
                addRepeater={addRepeater}
                validationErrors={validationErrors}
                onFormChange={onFormChange}
                onAddRepeaterRowClick={onAddRepeaterRowClick}
                onRepeaterLineChange={onRepeaterLineChange}
                onDeleteManualRepeaterRow={onDeleteManualRepeaterRow}
                onDeleteSearchRepeaterRow={onDeleteSearchRepeaterRow}
                onDeleteRemoveRepeaterRow={onDeleteRemoveRepeaterRow}
                onDeleteExchangeRepeaterPair={onDeleteExchangeRepeaterPair}
            />

            <OrderSearchModal
                open={orderSearchModalOpen}
                orderSearchResult={orderSearchResult}
                onClose={onOrderSearchModalClose}
                onSelectAllChange={onOrderSearchSelectAllChange}
                onRowToggle={onOrderSearchRowToggle}
                onRegisterClick={onOrderSearchRegisterClick}
            />
        </>
    );
}
